/** Shared Google Maps loader settings — keep libraries array stable across renders. */
export const GOOGLE_MAP_LIBRARIES: ('places' | 'geometry' | 'drawing')[] = ['places'];

export const googleMapsApiKey = (): string =>
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined)?.trim() ?? '';

export const defaultMapCenter = { lat: 5.6037, lng: -0.187 };

export const defaultMapZoom = 6;

export const selectedLocationZoom = 16;
